import VueCookie from 'vue-cookie';
import Router from '../router/index.js';
import Axios from 'axios'
import { resetState } from './index';
const User = {
  state: {
    user: {},
  },
  getters: {
    get_user: (state) => {
      return state.user;
    }
  },
  mutations: {
    set_user: (state, payload) => {
      state.user = payload;
    }
  },
  actions: {
    login: (context, payload) => {

      Axios.post(process.env.VUE_APP_CUSAFE_URL + '/oauth/token', {
        username: payload.username,
        password: payload.password,
        grant_type: 'password',
        client_id: process.env.VUE_APP_CUSAFE_CLIENTID,
        client_secret: process.env.VUE_APP_CUSAFE_CLIENTSECRET,

      }, {headers: {

      }})
        .then(response => {
          Axios.get(process.env.VUE_APP_CUSAFE_URL + '/api/user', {headers: {
              'authorization': "Bearer " + response.data.access_token
            }})
            .then(response2 => {
              context.commit('set_user', response2.data);
              VueCookie.set('access_token', response.data.access_token);
              VueCookie.set('refresh_token', response.data.refresh_token);
              Router.push({name: 'Dashboard'})
            })
            .catch(error => {

            })
        })
        .catch(error => {

        })

    },
    useUser: (context, payload) => {
      Axios.get(process.env.VUE_APP_CUSAFE_URL + '/api/user', {headers: {
          'authorization': "Bearer " + VueCookie.get('access_token')
        }})
        .then(response2 => {
          context.commit('set_user', response2.data);
        })
        .catch(error => {

        })
    },
    logout: (context, payload) => {

      VueCookie.delete('access_token');
      VueCookie.delete('refresh_token');

      Router.push({name: 'Login'});

      resetState();


    }
  },
  namespaced: true
}
export default User;
